var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",staticStyle:{"overflow-x":"hidden"}},[_c('Header',{staticClass:"absolute z-1 top-0 left-0 right-0 text-white"}),_c('div',{staticClass:"relative"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }